var map = {
	"./ion-action-sheet-controller_8.entry.js": [
		"6cff",
		"chunk-5ea9b069"
	],
	"./ion-action-sheet-ios.entry.js": [
		"659a",
		"chunk-5ea8fe43"
	],
	"./ion-action-sheet-md.entry.js": [
		"ef71",
		"chunk-5ebf1337"
	],
	"./ion-alert-ios.entry.js": [
		"0359",
		"chunk-39e12d7d"
	],
	"./ion-alert-md.entry.js": [
		"e19f",
		"chunk-39f93e4f"
	],
	"./ion-app_8-ios.entry.js": [
		"2038",
		"chunk-078cf7e6"
	],
	"./ion-app_8-md.entry.js": [
		"fe2c",
		"chunk-07a56233"
	],
	"./ion-avatar_3-ios.entry.js": [
		"7f73",
		"chunk-5eaa2a27"
	],
	"./ion-avatar_3-md.entry.js": [
		"1ff3",
		"chunk-5ea7759e"
	],
	"./ion-back-button-ios.entry.js": [
		"43f7",
		"chunk-5ea8134c"
	],
	"./ion-back-button-md.entry.js": [
		"be4a",
		"chunk-5ebdb22c"
	],
	"./ion-backdrop-ios.entry.js": [
		"9a26",
		"chunk-23fd1523"
	],
	"./ion-backdrop-md.entry.js": [
		"1362",
		"chunk-23f8c5f5"
	],
	"./ion-button_2-ios.entry.js": [
		"bbb4",
		"chunk-5bf90fd6"
	],
	"./ion-button_2-md.entry.js": [
		"2ce3",
		"chunk-5be34223"
	],
	"./ion-card_5-ios.entry.js": [
		"578d",
		"chunk-5ea8914a"
	],
	"./ion-card_5-md.entry.js": [
		"2dd3",
		"chunk-5ea7e23d"
	],
	"./ion-checkbox-ios.entry.js": [
		"7734",
		"chunk-5be4dcc5"
	],
	"./ion-checkbox-md.entry.js": [
		"484a",
		"chunk-5be383b5"
	],
	"./ion-chip-ios.entry.js": [
		"a5d5",
		"chunk-5ebc8f41"
	],
	"./ion-chip-md.entry.js": [
		"3874",
		"chunk-5ea7abfe"
	],
	"./ion-col_3.entry.js": [
		"d264",
		"chunk-2d21d882"
	],
	"./ion-datetime_3-ios.entry.js": [
		"8d91",
		"chunk-aa1c7316"
	],
	"./ion-datetime_3-md.entry.js": [
		"dd04",
		"chunk-a9f47496"
	],
	"./ion-fab_3-ios.entry.js": [
		"7748",
		"chunk-5ea97960"
	],
	"./ion-fab_3-md.entry.js": [
		"6ae6",
		"chunk-5ea9a898"
	],
	"./ion-img.entry.js": [
		"4633",
		"chunk-2d0c1558"
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		"1ea0",
		"chunk-bd911bc2"
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		"7526",
		"chunk-bd8d1b04"
	],
	"./ion-input-ios.entry.js": [
		"6a60",
		"chunk-5be50669"
	],
	"./ion-input-md.entry.js": [
		"9111",
		"chunk-5be5aebc"
	],
	"./ion-item-option_3-ios.entry.js": [
		"ef10",
		"chunk-5bfa7604"
	],
	"./ion-item-option_3-md.entry.js": [
		"ba59",
		"chunk-5bf906a7"
	],
	"./ion-item_8-ios.entry.js": [
		"b665",
		"chunk-5ebd01cf"
	],
	"./ion-item_8-md.entry.js": [
		"1768",
		"chunk-5ea6bf64"
	],
	"./ion-loading-ios.entry.js": [
		"d773",
		"chunk-39f8e005"
	],
	"./ion-loading-md.entry.js": [
		"c500",
		"chunk-39f86348"
	],
	"./ion-menu_4-ios.entry.js": [
		"b1ab",
		"chunk-2e1f7d8d"
	],
	"./ion-menu_4-md.entry.js": [
		"3e30",
		"chunk-2e0add8c"
	],
	"./ion-modal-ios.entry.js": [
		"c9e1",
		"chunk-4f34c07f"
	],
	"./ion-modal-md.entry.js": [
		"fff0",
		"chunk-4f36c6a7"
	],
	"./ion-nav_4.entry.js": [
		"a2be",
		"chunk-98779fc2"
	],
	"./ion-popover-ios.entry.js": [
		"1c07",
		"chunk-4f1e9d36"
	],
	"./ion-popover-md.entry.js": [
		"304d",
		"chunk-4f1ec72a"
	],
	"./ion-progress-bar-ios.entry.js": [
		"ba1a",
		"chunk-5bf90653"
	],
	"./ion-progress-bar-md.entry.js": [
		"73fe",
		"chunk-5be4d41f"
	],
	"./ion-radio_2-ios.entry.js": [
		"88c7",
		"chunk-5be55ab8"
	],
	"./ion-radio_2-md.entry.js": [
		"2e5b",
		"chunk-5be34404"
	],
	"./ion-range-ios.entry.js": [
		"da8e",
		"chunk-5bf9efee"
	],
	"./ion-range-md.entry.js": [
		"a38a",
		"chunk-5bf7e61f"
	],
	"./ion-refresher_2-ios.entry.js": [
		"3d91",
		"chunk-bd8f5b76"
	],
	"./ion-refresher_2-md.entry.js": [
		"87b7",
		"chunk-bd8c17a0"
	],
	"./ion-reorder_2-ios.entry.js": [
		"e315",
		"chunk-6d894016"
	],
	"./ion-reorder_2-md.entry.js": [
		"1b77",
		"chunk-6db72458"
	],
	"./ion-ripple-effect.entry.js": [
		"9994",
		"chunk-2d0e6731"
	],
	"./ion-route_4.entry.js": [
		"d8ad",
		"chunk-5bf95afb"
	],
	"./ion-searchbar-ios.entry.js": [
		"8691",
		"chunk-21626da4"
	],
	"./ion-searchbar-md.entry.js": [
		"4705",
		"chunk-21609ed6"
	],
	"./ion-segment_2-ios.entry.js": [
		"0e7c",
		"chunk-5ea6f7fd"
	],
	"./ion-segment_2-md.entry.js": [
		"1dd0",
		"chunk-5ea76ddb"
	],
	"./ion-select_3-ios.entry.js": [
		"5c6e",
		"chunk-5be499c1"
	],
	"./ion-select_3-md.entry.js": [
		"6cb2",
		"chunk-5be51341"
	],
	"./ion-slide_2-ios.entry.js": [
		"6dea",
		"chunk-798bb258"
	],
	"./ion-slide_2-md.entry.js": [
		"6ba2",
		"chunk-798bc2b2"
	],
	"./ion-spinner.entry.js": [
		"b552",
		"chunk-5ebcfdec"
	],
	"./ion-split-pane-ios.entry.js": [
		"8e68",
		"chunk-2d0e97a5"
	],
	"./ion-split-pane-md.entry.js": [
		"0baa",
		"chunk-2d0aeec8"
	],
	"./ion-tab-bar_2-ios.entry.js": [
		"ec59",
		"chunk-5ebf07be"
	],
	"./ion-tab-bar_2-md.entry.js": [
		"edb4",
		"chunk-5ebf10ed"
	],
	"./ion-tab_2.entry.js": [
		"7914",
		"chunk-6d361d06"
	],
	"./ion-text.entry.js": [
		"6770",
		"chunk-5ea90556"
	],
	"./ion-textarea-ios.entry.js": [
		"da20",
		"chunk-5bf9eeff"
	],
	"./ion-textarea-md.entry.js": [
		"c228",
		"chunk-5bf8ca39"
	],
	"./ion-toast-ios.entry.js": [
		"2671",
		"chunk-39e221b4"
	],
	"./ion-toast-md.entry.js": [
		"9076",
		"chunk-39e539cc"
	],
	"./ion-toggle-ios.entry.js": [
		"2028",
		"chunk-aa236f96"
	],
	"./ion-toggle-md.entry.js": [
		"bc51",
		"chunk-a9f64c64"
	],
	"./ion-virtual-scroll.entry.js": [
		"514e",
		"chunk-2d0c7743"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8b81";
module.exports = webpackAsyncContext;